import { render, staticRenderFns } from "./TitleArea.vue?vue&type=template&id=bb9a5138&scoped=true&"
import script from "./TitleArea.vue?vue&type=script&lang=ts&"
export * from "./TitleArea.vue?vue&type=script&lang=ts&"
import style0 from "./TitleArea.vue?vue&type=style&index=0&id=bb9a5138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb9a5138",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
